<template>
  <Dialog class="downloadPop" v-on="$listeners" v-bind="$props" noOkBtn noCancelBtn>
    <!-- <div :class="$style.title">登录丽芙家居APP<br />可查看你获得的礼品券</div>
    <a :href="$paths.appDownload()"><button :class="$style.btn">点击打开APP</button></a>-->
    <img :class="$style.img" :src="img" @click="$service.gotoUrl($paths.appDownload())" alt />
  </Dialog>
</template>

<script>
import Dialog from "../Dialog";

export default {
  name: "DialogDownloadApp",
  props: {
    ...Dialog.props,
    img: {
      type: String,
      default:
        "https://lanhu.oss-cn-beijing.aliyuncs.com/SketchSlicePngd4130d4934b4c6d68ce834dc8bf0c6ce"
    }
  },
  components: {
    Dialog
  }
};
</script>

<style lang="scss">
.downloadPop.Dialog {
  .Dialog__close {
    top: 0;
    right: 0;
  }
  .Dialog__box {
    background: transparent;
    max-width: none;
    width: rem(345);
    height: rem(434);
  }
  .Dialog__body {
    padding: 0;
  }
  .Dialog__title {
    display: none;
  }
}
</style>

<style lang="scss" module>
@import "~style/tool";

.title {
  font-size: rem(21px);
  color: rgba(51, 51, 51, 1);
  line-height: rem(32px);
}

.btn {
  margin-top: rem(35px - 8);
  width: rem(255px);
  height: rem(50px);
  line-height: rem(50px);
  background: rgba(233, 90, 89, 1);
  border-radius: rem(25px);
  font-size: 17px;
  color: rgba(255, 255, 255, 1);
}

.img {
  display: block;
  width: 100%;
  height: 100%;
}
</style>
